import style from "./GrayBtn.module.css";

function GrayBtn(props) {
  var className = style.GrayBtn + " ";
  if (props.className) {
    className += props.className;
  }
  return (
    <button className={className} {...props}>
      <props.variant className={style.GrayBtnTxt}>
        {props.children}
      </props.variant>
    </button>
  );
}

export default GrayBtn;
